import {
  TestBasketItem,
  ShippingTestBasketItem,
  ConsultationBasketItem,
} from '../provider/basket'

type ItemWithProfile =
  | TestBasketItem
  | ShippingTestBasketItem
  | ConsultationBasketItem

export const sortProfile = (a: ItemWithProfile, b: ItemWithProfile) => {
  return (a.profile?.id || 0) > (b.profile?.id || 0) ? 1 : -1
}
